module.exports = __webpack_public_path__ + "img/icon_map_6_off_010.87d3c3bd.png";